import type { RouteRecordRaw } from "vue-router"

import { isAuthenticated } from "@/routers/router-guardians"

const routes: Array<RouteRecordRaw> = [
  {
    path: "/e-prescribe",
    name: "e-prescribe",
    props: () => ({
      ePrescribingLink: window.history.state?.ePrescribingLink,
      previousStepUrl: window.history.state?.previousStepUrl
    }),
    component: () => import(/* webpackChunkName: "e-prescribe" */ "@/modules/medication/pages/EPrescribe.vue"),
    beforeEnter(to, from, next) {
      isAuthenticated(to, from, next)
    }
  },
  {
    path: "/authorize-ayva",
    name: "authorize-ayva",
    component: () => import(/* webpackChunkName: "e-prescribe" */ "@/modules/medication/pages/AuthorizeAyva.vue"),
    beforeEnter(to, from, next) {
      isAuthenticated(to, from, next)
    }
  }
]

export default routes
